import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { Sidebar } from '../../BulkActionsSidebar'
import { FormFields } from './FormFields'
import {
  BulkReopenFormModel,
  SubmitCallback,
  ValidationCallback,
} from './typings'
import { useFormActions } from './hooks'
import { FormikErrors } from 'formik'
import { useData } from '@user/components/xGrid/atoms/BulkActions/BulkReopen/BulkReopenForm/hooks/useData'

type Props = {
  entityType: ENTITY_TYPES
  validateRows: ValidationCallback
  onSubmit: SubmitCallback
}

export const BulkReopenForm: React.FC<Props> = (props) => {
  const { onSubmit, entityType } = props
  const { initialValues, owners, selectedRowCount } = useData(props)

  const submitHandler = useFormActions(onSubmit)

  const validate = React.useCallback(
    (values: BulkReopenFormModel) => {
      const errors: FormikErrors<BulkReopenFormModel> = {}
      if (entityType === ENTITY_TYPES.Opportunity) {
        if (
          values.expectedClosingDate === null ||
          isNaN(new Date(values.expectedClosingDate).getTime())
        ) {
          errors.expectedClosingDate = 'Required'
        }
      }
      if (selectedRowCount === 1 && values.owner === null)
        errors.owner = 'Required'
      return errors
    },
    [entityType, selectedRowCount],
  )

  return (
    <Sidebar
      title="Re-open"
      initialValues={initialValues}
      onSubmit={submitHandler}
      validate={validate}
    >
      <FormFields
        {...props}
        owners={owners}
        selectedRowCount={selectedRowCount}
      />
    </Sidebar>
  )
}
BulkReopenForm.displayName = 'BulkReopenForm'
